export const FormToggle_ACTION_TYPES = {
  TOGGLE_EDIT: "toggleForm/edit",
  TOGGLE_CREATE: "toggleForm/create",
}